import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { FilterChangedEvent, GridApi, GridOptions } from '@ag-grid-community/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


interface ColumnDefinitionHash {
  [s: string]: {
    headerName: string;
  };
}

@Component({
  selector: 'app-active-filters',
  templateUrl: './active-filters.component.html',
  styleUrls: ['./active-filters.component.scss']
})
export class ActiveFiltersComponent implements OnChanges, OnDestroy, OnInit {
  // TODO: This needs to be moved to a shared module. There is one in progress in another branch so it can be moved after the merge
  @Input() columnDefs; // AG Grid column definitions
  @Input() gridOptions: GridOptions;
  @Input() gridApi: GridApi;
  @Input() filtersChanged: Observable<FilterChangedEvent>;

  filtersActive: boolean;
  activeFilters: any[];
  columnDefHash: ColumnDefinitionHash;
  onDestroy$: Subject<void> = new Subject();

  constructor() {
    this.activeFilters = [];
  }

  ngOnInit(): void {
    this.filtersChanged
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(event => this.onFilterChanged(event));
  }

  ngOnChanges(): void {
    this.columnDefHash = this.columnDefs.reduce((collection, col) => {
      collection[col.field] = {
        headerName: col.headerName
      };
      return collection;
    }, {});
  }

  clearAccessFilter(col = null): void {
    if (col === null) {
      this.gridOptions.api.setFilterModel(null);
    } else {
      const filterComponent = this.gridApi.getFilterInstance(col.key);
      filterComponent.setModel(null);

      if (this.gridApi) {
        this.gridApi.onFilterChanged();
      }
    }
  }

  onFilterChanged(event: FilterChangedEvent): void {
    const filters = event.api.getFilterModel();
    const fields = Object.keys(filters);

    this.filtersActive = Boolean(fields.length);
    this.activeFilters = fields.map((col) => ({
      key: col,
      name: this.columnDefHash[col].headerName
    }));
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(null);
  }
}
